import { useEffect, useState, useRef } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { RiVoiceprintLine, RiGlobalLine } from "react-icons/ri";
import { MdKeyboardVoice } from "react-icons/md";
import { BiChip } from "react-icons/bi";
import { IoArrowForward } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";

import { Link } from "react-router-dom";
// import { Tooltip } from "bootstrap";
import { RiFilePdf2Line, RiAttachment2 } from "react-icons/ri";
import { IoClose } from "react-icons/io5";

import axios from "axios";
import AiResponseModal from "../modelpopup/AiResponseModal";
import { Tooltip } from "react-tooltip";
import TransactionsModal from "../modelpopup/TransactionsModal";
const promptIntro = `
  أنت مستشار ذو خبرة 30 عامًا في التحليل المالي والتحقيقات المالية. خبير عالمي في الضرائب الدولية، التكنولوجيا المالية (Fintech)، العملات الرقمية، المحاسبة والتدقيق. عملت مع الحكومات، البنوك، الشركات الكبرى، وفرق مكافحة الجرائم المالية. أنت لا ترتكب أخطاء. دقتك لا تُضاهى. اكتب الرد التالي وكأن سمعتك العالمية ومصداقيتك المهنية على المحك. لا تقدم كلامًا عامًا أو غير مدعوم — فقط تحليلات دقيقة، واقعية، ومبنية على أفضل الممارسات العالمية. 
  أجب السؤال الآتي:\n
`;

const GEMINI_API = "AIzaSyAetO_cbRT-jKsFQEdWN4W-G5AonyU3Fgk";
// const GEMINI_API = process.env.GEMINI_API_KEY;
const OPEN_AI = process.env.REACT_APP_OPEN_AI_API_KEY;

export default function BookBotSearchBar({
  onFileUpload,
  triggerUpload,
  reset,
  fileTypeObject,
}) {
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState("");
  const [response, setResponse] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  const askOpenAi = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiUrl = "https://api.openai.com/v1/chat/completions";

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${OPEN_AI}`, // Make sure OPEN_AI is defined
      };

      const requestBody = {
        model: "gpt-4",
        messages: [
          {
            role: "system",
            content: promptIntro,
          },
          {
            role: "user",
            content: input,
          },
        ],
        max_tokens: 500, // Adjust based on your need
        temperature: 0.7, // Balance between creativity and accuracy
        top_p: 1.0,
        n: 1,
      };

      const { data } = await axios.post(apiUrl, requestBody, { headers });

      setResponse(data.choices[0].message.content);
      setLoading(false);
      setShowModal(true);
    } catch (error) {
      console.error(
        "Error sending message:",
        error.response?.data || error.message
      );
    }
  };

  const handleGeminiAsking = async (e) => {
    e.preventDefault();
    if (file) askGeminiWithFiles(e);
    else askGemini(e);
  };

  const askGemini = async (e) => {
    e.preventDefault();

    const genAI = new GoogleGenerativeAI(GEMINI_API);
    setLoading(true);
    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // You can choose other models like 'gemini-pro'

      const result = await model.generateContent(
        `${fileTypeObject["prompt_ar"]}`
      );

      const textResponse = await result.response.text();
      console.log(result);
      setResponse(textResponse);
      setShowModal(true);
    } catch (err) {
      console.error("Error calling Gemini API:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (triggerUpload) {
      handleAddFile();
    }
  }, [triggerUpload]);

  const askGeminiWithFiles = async (e) => {
    e.preventDefault();
    const genAI = new GoogleGenerativeAI(GEMINI_API);
    setLoading(true);

    try {
      const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" }); // You can choose other models like 'gemini-pro'
      // const parts = [{ text: `${promptIntro} ${input}` }];
      const parts = [];
      const textPrompt = `
      You are a smart accountant with 30 years of experience. Read the attached file, which is a list of expense invoices. Some invoices may also have attached payment details. After thoroughly reading all the invoices, create a JSON file (do not append to an existing file) that includes all the invoice details in the following exact format, with all values extracted from the document:

{
  "document_name": "",
  "type": "",
  "bank_transfer_details": {
    "request_received_date": "",
    "sender": "",
    "sender_account": "",
    "sender_bank": "",
    "amount": "",
    "recipient": "",
    "recipient_account": "",
    "recipient_bank": "",
    "transfer_execution_date": "",
    "reference_number": "",
    "transfer_details": "",
    "total_fees": ""
  },
  "invoice_receipt_details": {
    "document_type": "",
    "date": "",
    "time": "",
    "invoice_number": "",
    "customer_number": "",
    "supplier": "",
    "supplier_address": "",
    "supplier_phone": "",
    "supplier_fax": "",
    "supplier_authorized_dealer_number": "",
    "recipient_name": "",
    "recipient_address": "",
    "items": [
      {
        "item_number": "",
        "description": "",
        "quantity": "",
        "unit_price_ils": "",
        "total_ils": ""
      }
    ],
    "total_before_vat": "",
    "discount_percentage": "",
    "discount_amount": "",
    "total_after_discount": "",
    "vat_percentage": "",
    "vat_amount": "",
    "total_due": "",
    "payment_details": [
      {
        "line_details": "",
        "payment_type": "",
        "payment_date": "",
        "amount_ils": ""
      }
    ]
  }
}
`;
      parts.push({ text: textPrompt });

      if (file) {
        const base64Data = await readFileAsBase64(file);
        parts.push({
          inlineData: {
            mimeType: file.type,
            data: base64Data.split(",")[1], // Extract the base64 payload
          },
        });
      }

      const result = await model.generateContent({
        contents: [{ role: "user", parts }],
      });

      const textResponse = await result.response.text();
      const json = extractJSONFromText(textResponse);
      window.localStorage.setItem("expensesData", JSON.stringify(json));
      console.log(json);
      setResponse(textResponse);
      setShowModal(true);
    } catch (err) {
      console.error("Error calling Gemini API:", err);
    } finally {
      setLoading(false);
      setFile(null);
    }
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  function extractJSONFromText(text) {
    const stack = [];
    let startIndex = -1;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      if (char === "{" || char === "[") {
        if (stack.length === 0) startIndex = i;
        stack.push(char);
      } else if (char === "}" || char === "]") {
        const last = stack[stack.length - 1];
        if ((char === "}" && last === "{") || (char === "]" && last === "[")) {
          stack.pop();
          if (stack.length === 0) {
            const jsonCandidate = text.slice(startIndex, i + 1);
            try {
              const parsed = JSON.parse(jsonCandidate);
              return parsed; // First valid JSON block found
            } catch (err) {
              // Ignore and continue
            }
          }
        } else {
          // Mismatched brackets, reset
          stack.length = 0;
        }
      }
    }

    return null; // No valid JSON found
  }

  // Download JSON as file
  function downloadJSON(data, filename = "output.json") {
    const blob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }

  const handleAddFile = () => {
    const inputFile = document.createElement("input");
    inputFile.type = "file";
    inputFile.accept =
      "application/pdf,image/png,image/jpeg,image/webp,text/plain";

    inputFile.onchange = () => {
      const selectedFile = inputFile.files?.[0];
      if (selectedFile) {
        setFile(selectedFile);
        setInput(fileTypeObject.inputText);
        document.getElementById("prompt-input").focus();

        if (onFileUpload) {
          onFileUpload(selectedFile);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    };

    inputFile.click();
  };

  useEffect(() => {
    if (reset) {
      setInput("");
      setFile(null);
      setResponse("");
      setShowModal(false);
      setLoading(false);
    }
  }, [reset]);

  return (
    <div className="row">
      <h1 className="ai-title">
        <span>BookBot</span>
      </h1>
      <div
        className={
          loading
            ? "loading-opacity col-sm-12 col-md-12"
            : "col-sm-12 col-md-12"
        }
      >
        <div className="d-flex justify-content-center  mt-3 search-component ">
          <form className="w-100" onSubmit={handleGeminiAsking}>
            <div
              className={
                file
                  ? "search-box position-relative  height-more "
                  : "search-box position-relative"
              }
            >
              <input
                type="text"
                className="form-control border-0 search-bar-input text-white"
                placeholder="اسأل Mass..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                id="prompt-input"
              />

              <div
                className={
                  file
                    ? "d-flex   gap-2 mt-3 search-bar-div justify-content-between"
                    : "d-flex   gap-2 mt-3 search-bar-div "
                }
              >
                {file && (
                  <div className="file-preview-inside ">
                    <div className="d-flex align-items-start">
                      {file.type === "application/pdf" ? (
                        <RiFilePdf2Line
                          size={20}
                          className="text-danger me-2"
                        />
                      ) : (
                        <RiAttachment2 size={20} className="me-2" />
                      )}
                      <div
                        className="text-truncate"
                        style={{ maxWidth: "120px" }}
                      >
                        <div className="fw-bold small text-white">
                          {file.name}
                        </div>
                        <div className="small text-muted">{file.size} MB</div>
                      </div>
                      <button
                        className="btn btn-sm "
                        onClick={() => setFile(null)}
                        type="button"
                      >
                        <IoCloseOutline className="btn-close-file" size={14} />
                      </button>
                    </div>
                  </div>
                )}
                <div className="d-flex gap-2 search-bar-btns flex-row-reverse mb-4 mt-2">
                  <Link
                    to="#"
                    className="active"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Enter"
                    onClick={handleGeminiAsking}
                  >
                    <IoArrowForward size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Voice Mode"
                  >
                    <RiVoiceprintLine size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Dictation"
                  >
                    <MdKeyboardVoice size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Attach files"
                    onClick={handleAddFile}
                  >
                    <RiAttachment2 size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Set sources for research"
                  >
                    <RiGlobalLine size={20} />
                  </Link>

                  <Link
                    to="#"
                    data-tooltip-id="shared-tooltip"
                    data-tooltip-content="Choose a model"
                  >
                    <BiChip size={20} />
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {loading ? (
        <div className=" mt-4" dir="ltr">
          <div className="d-flex flex-row gap-2 bold  justify-content-center">
            <span className="pt-2 "> Analyzing ...</span>
            <div
              className="spinner-grow text-primary m-2 opacity-0"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-0 "
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-25"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-25"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-50"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-50"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-75"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-75"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-100"
              role="status"
            />
            <div
              className="spinner-grow text-primary m-2 opacity-100"
              role="status"
            />
            {/*end card-body*/}
          </div>
        </div>
      ) : (
        <TransactionsModal
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
      <Tooltip id="shared-tooltip" place="top" className="my-tooltip-custom" />
    </div>
  );
}
